import { Avatar, Card, Col, Row, Space, Typography } from 'antd'
import React from 'react'
import { displayNumbers } from '../../../variables/numbersFunctions'
import { FileTextOutlined, MedicineBoxOutlined } from '@ant-design/icons'

const { Title, Text } = Typography;

const StatsSummary = ({ globalStats, colors }) => {
    return (
        <Row gutter={[16, 16]}>
            {/* Production mois en cours */}
            <Col xs={24} md={12}>
                <Card
                    style={{
                        borderRadius: '12px',
                        border: `1px solid ${colors.light}`,
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                    }}
                    bodyStyle={{ padding: '24px' }}
                >
                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                        <Avatar
                            size={48}
                            style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}
                            icon={<FileTextOutlined style={{ color: 'white' }} />}
                        />
                        <div>
                            <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: '16px' }}>
                                Production
                            </Text>
                            <Title level={3} style={{ color: 'white', margin: '8px 0' }}>
                                {displayNumbers(globalStats.totalProductionMoisCourant)} FCFA
                            </Title>
                            <Text style={{ color: 'rgba(255,255,255,0.8)' }}>
                                Primes encaissées (Mois en cours)
                            </Text>
                        </div>
                    </Space>
                </Card>
            </Col>

            {/* Sinistres payés mois en cours */}
            <Col xs={24} md={12}>
                <Card
                    style={{
                        borderRadius: '12px',
                        border: `1px solid ${colors.light}`,
                        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
                    }}
                    bodyStyle={{ padding: '24px' }}
                >
                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                        <Avatar
                            size={48}
                            style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}
                            icon={<MedicineBoxOutlined style={{ color: 'white' }} />}
                        />
                        <div>
                            <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: '16px' }}>
                                Sinistres payés
                            </Text>
                            <Title level={3} style={{ color: 'white', margin: '8px 0' }}>
                                {displayNumbers(globalStats.totalMontantSinistresPayesMoisCourant)} FCFA
                            </Title>
                            <Text style={{ color: 'rgba(255,255,255,0.8)' }}>
                                Mois en cours
                            </Text>
                        </div>
                    </Space>
                </Card>
            </Col>

            {/* Production exercice précédent */}
            <Col xs={24} md={12}>
                <Card
                    style={{
                        borderRadius: '12px',
                        border: `1px solid ${colors.light}`,
                        background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
                    }}
                    bodyStyle={{ padding: '24px' }}
                >
                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                        <Avatar
                            size={48}
                            style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}
                            icon={<FileTextOutlined style={{ color: 'white' }} />}
                        />
                        <div>
                            <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: '16px' }}>
                                Production
                            </Text>
                            <Title level={3} style={{ color: 'white', margin: '8px 0' }}>
                                {displayNumbers(globalStats.totalProductionExercicePrecedent)} FCFA
                            </Title>
                            <Text style={{ color: 'rgba(255,255,255,0.8)' }}>
                                Exercice précédent
                            </Text>
                        </div>
                    </Space>
                </Card>
            </Col>

            {/* Sinistres exercice précédent */}
            <Col xs={24} md={12}>
                <Card
                    style={{
                        borderRadius: '12px',
                        border: `1px solid ${colors.light}`,
                        background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)'
                    }}
                    bodyStyle={{ padding: '24px' }}
                >
                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                        <Avatar
                            size={48}
                            style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}
                            icon={<MedicineBoxOutlined style={{ color: 'white' }} />}
                        />
                        <div>
                            <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: '16px' }}>
                                Sinistres payés
                            </Text>
                            <Title level={3} style={{ color: 'white', margin: '8px 0' }}>
                                {displayNumbers(globalStats.totalMontantSinistresPayesExercicePrecedent)} FCFA
                            </Title>
                            <Text style={{ color: 'rgba(255,255,255,0.8)' }}>
                                Exercice précédent
                            </Text>
                        </div>
                    </Space>
                </Card>
            </Col>
        </Row>
    )
}

export default StatsSummary